module.exports = __webpack_public_path__ + "media/customize/banner-bottom-left-bc0d7117.svg";